<template>
  <span>
    <span @click="showModal">
      <slot></slot>
    </span>

    <b-modal v-model="modalView" size="lg" centered no-fade>
      <div slot="modal-header">{{$t('DOCUMENTS.SELECT.TITLE')}}</div>
      <div>
           
        <b-form class="pt-1 pb-1">
          <b-form-input autofocus class="i-100" v-model="searchText" :placeholder="$t('SEARCH')"></b-form-input>
        </b-form>
        
        <b-table small hover :items="items" :fields="fields">
          <template v-slot:cell(name)="data">
            <div  class="clickable" @click="selectDocument(data.item.dclIdentity)"> 
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(version)="data">
            <div  class="clickable" @click="selectDocument(data.item.dclIdentity)"> 
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(dclIdentity)="data">
            <div  class="clickable" @click="selectDocument(data.item.dclIdentity)"> 
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(publishedDate)="data">
            <div  class="clickable" @click="selectDocument(data.item.dclIdentity)"> 
              {{ $moment(data.value) | moment("YYYY-MM-DD HH:mm") }}
            </div>
          </template>
        </b-table>

       
         
      </div>
      <div slot="modal-footer" class="w-100">
        <div>
          <b-btn @click="hideModal">{{ $t('CLOSE')}}</b-btn>
        </div>
      </div>
    </b-modal>
  </span>
</template>
<script>
export default {
  props: ["version"],
  data() {
    return {
      modalView: false,
      modalLoading: false,
      searchText: "",
      items: [],
      totalItems: 0,
      currentPage: 0,
      limit: 3,
      fields: [
        { key: 'name', label: this.$t('DOCUMENTS.SELECT.TABLE.NAME') },
        { key: 'version', label: this.$t('DOCUMENTS.SELECT.TABLE.VERSION') },
        { key: 'dclIdentity', label: this.$t('DOCUMENTS.SELECT.TABLE.DCLIDENTITY') },
        { key: 'publishedDate', label: this.$t('DOCUMENTS.SELECT.TABLE.PUBLISHED_DATE') }
      ],
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    showModal() {
      this.modalView = true;
    },
    hideModal() {
      this.searchText = "";
      this.modalLoading = false;
      this.modalView = false;
      this.items = [];
      this.totalItems = 0;
    },  
    selectDocument: function(dclIdentity) {
      this.$emit("selectedDocument",dclIdentity);
      this.hideModal();
    },
    searchDocument: function() {
      this.modalLoading = true;
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + `/search/documents/team`, {
          searchText: this.searchText,
          page: this.currentPage,
          limit: this.limit, 
          version: 0   
        })
        .then(function(response) {
          self.modalLoading = false;
          self.items = response.data.items; 
          self.totalItems = response.data.total; 
        })
        .catch(function() {
          self.modalLoading = false;
        });
    }
  },
  watch: {    
    searchText: function() {
      if(this.modalView ==  true)
      {
        if (this.searchText.length == 0) {
          this.items = [];
          this.totalItems = 0;
        }
        if (this.searchText.length >= 3) {
            this.searchDocument();
        }
      }
    }
  }
};
</script>
<style>
</style>